import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getRTMList: async (appId, userId) => {
      const options = createRequestOptions({ appId, userId });

      const result = await fetch(
        Config.serverUrl + "/GetRTMListForApp",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getRTMListForOrg: async (orgId) => {
      const options = createRequestOptions({ orgId });

      const result = await fetch(
        Config.serverUrl + "/GetRTMListForOrg",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    addInteraction: async (
      cappId,
      interactionDate,
      type,
      description,
      length
    ) => {
      const options = createRequestOptions({
        cappId,
        interactionDate,
        type,
        description,
        length,
      });

      const result = await fetch(Config.serverUrl + "/AddInteraction", options);
      const response = await result.json();

      return get(response, "response");
    },
    markCustomAppBilledFor: async (cappId, providerId) => {
      const options = createRequestOptions({
        cappId,
        providerId,
      });

      const result = await fetch(
        Config.serverUrl + "/MarkCustomAppBilledFor",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    removePatientFromRTM: async (cappId, providerId) => {
      const options = createRequestOptions({
        cappId,
        providerId,
      });

      const result = await fetch(
        Config.serverUrl + "/RemovePatientFromRTM",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    markClaimGeneratedFor: async (cappId, providerId) => {
      const options = createRequestOptions({
        cappId,
        providerId,
      });

      const result = await fetch(
        Config.serverUrl + "/MarkClaimGeneratedFor",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getRtmBillingReport: async (
      customAppId,
      patientId,
      providerId,
      startDate,
      endDate
    ) => {
      const options = createRequestOptions({
        customAppId,
        patientId,
        providerId,
        startDate,
        endDate,
      });

      const result = await fetch(
        Config.serverUrl + "/GetRTMBillingReport",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    inesrtBillingInfo: async (customAppId, billingCode, billingDate) => {
      const options = createRequestOptions({
        customAppId,
        billingCode,
        billingDate,
      });

      const result = await fetch(
        Config.serverUrl + "/InsertBillingInfo",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/rtm.js